import { Skeleton } from '@ui/Skeleton';
import { StarsSkeleton } from '@ui/Stars';

import s from './UserReview.sss';

export const UserReviewSkeleton = () => (
  <div className={s.root}>
    <Skeleton
      type="circle"
      width="60px"
      height="60px"
    />

    <div className={s.reviewBlock}>
      <div className={s.firstLine}>
        <Skeleton
          width="100px"
          height="12px"
        />
        <div className={s.date}>
          <Skeleton
            width="50px"
            height="12px"
          />
        </div>
      </div>

      <StarsSkeleton className={s.rating} />

      <div className={s.text}>
        <Skeleton
          width="30%"
          height="12px"
        />
        <Skeleton
          width="50%"
          height="12px"
        />
      </div>
    </div>
  </div>
);
